import Home from 'components/Home';

export default {
  path: '(:locale)',
  Component: Home
};
